import Vue from 'vue';

export class MkdbService {
  mkdbUrl;

  constructor(mkdbUrl) {
    this.mkdbUrl = mkdbUrl;
    this.fairsApiRoot = `${ this.mkdbUrl }/rest/v1.0/fair`;
  }

  async getFair(fairUid) {
    try {
      const response = await Vue.prototype.axios({
        method: 'get',
        url: `${ this.fairsApiRoot }/${ fairUid }`,
        headers: this.getHeaderData(),
      });
      if (response.data && response.data.success && response.data.data[fairUid]) {
        return response.data.data[fairUid];
      }
      return null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  getHeaderData() {
    return {
      'content-type': 'application/json; charset=utf-8',
    };
  }
}
